module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/a8c1a72c6b035dc67c851ad45e3a2bc5.png";